export function toggleBulletPoints(selectedText) {
  if (!selectedText) return '';

  const lines = selectedText.split('\n');

  const allBulleted = lines.every(line => line.trim().startsWith('• '));

  if (allBulleted) {
    // Remove bullets
    return lines.map(line =>
      line.trim().startsWith('• ') ? line.replace(/^(\s*)•\s*/, '$1') : line
    ).join('\n');
  } else {
    // Add bullets
    return lines.map(line => line.trim() === '' ? line : `• ${line}`).join('\n');
  }
}
